import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import clsx from 'clsx';
import { verifyCode } from './core/_requests'; // adjust the path if needed
import { CardValidation } from './core/_models';
import './style/validate-card.css'; // new stylesheet

const ValidateCardAPI: React.FC = () => {
  const location = useLocation();
  const [cardValidation, setCardValidation] = useState<CardValidation | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const key = searchParams.get('code');

    if (key) {
      verifyCode(key)
        .then((response) => {
          setCardValidation(response.data.result);
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching validation:", error);
          setCardValidation({
            isValid: false,
            errorMessage: "Error validating card",
            graduateFullName: "",
            graduateYear: "",
            faculty : "",
            department : ""
          });
          setLoading(false);
        });
    } else {
      setCardValidation({
        isValid: false,
        errorMessage: "Missing card key in URL",
        graduateFullName: "",
        graduateYear: "",
        faculty : "",
        department : ""
      });
      setLoading(false);
    }
  }, [location.search]);

  if (loading) {
    return (
      <div className="kt-container d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="sr-only">Yükleniyor...</span>
        </div>
      </div>
    );
  }

  const isValid = cardValidation?.isValid;
  return (
    <div className="kt-container d-flex justify-content-center align-items-center vh-100">
      <div className="validation-card text-center p-5 m-3">
        <div
          className={clsx(
            'icon-circle',
            isValid ? 'icon-success' : 'icon-fail'
          )}
        >
          {isValid ? '✓' : '✕'}
        </div>
        <h2 className={isValid ? 'text-success' : 'text-danger'}>
          {isValid ? 'Mezun Kartı Doğrulandı' : 'Mezun Kartı Doğrulanamadı'}
        </h2>
        <p >
          {isValid
            ? 
              (
                <div className='pt-5'>
                  <p>Adı Soyadı : {cardValidation?.graduateFullName}</p>
                  <p>Fakültesi : {cardValidation?.faculty}</p>
                  <p>Bölümü : {cardValidation?.department}</p>
                  <p>Mezuniyet Yılı : {cardValidation?.graduateYear}</p>
                </div>
              )
            : cardValidation?.errorMessage}
        </p>
      </div>
    </div>
  );
};

export default ValidateCardAPI;
